import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: [
    'DV_DP_EPISODE_EXPANDER',
    'DV_DP_EPISODE_NUM_ASCENDING',
    'DV_DP_EPISODE_NUM_DESCENDING',
    'DV_DP_EPISODE_AVAILABLE',
    'DV_DP_EPISODE_SORT_BY',
  ] as const,
}
